import { GetStaticProps } from "next";
import Head from "next/head";

import PrivacyComponent from "../../components/Privacy";
import { FlashPCBPage } from "../../models/page";

interface PrivacyPageProps {
  privacyHtml: string;
}

const Privacy: FlashPCBPage<PrivacyPageProps> = ({ privacyHtml }) => {
  return (
    <>
      <Head>
        <title>Privacy</title>
        <meta name="description" content="Privacy Policy" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <PrivacyComponent privacyHtml={privacyHtml} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const response = await fetch(
    "https://www.iubenda.com/api/privacy-policy/93579599/no-markup",
  );
  const { content: privacyHtml } = (await response.json()) as {
    content: string;
  };
  return {
    props: {
      privacyHtml,
    } as PrivacyPageProps,
  };
};

export default Privacy;
